export default __webpack_public_path__ + "static/media/Play 2 Earn (P2E).e12e57be.png";